import React from "react"
import { Button } from "../ui/button"

interface Props {
  setOpenModal: (open: boolean) => void
  dynamicURL: any
}

const JoinModal: React.FC<Props> = ({ setOpenModal, dynamicURL }) => {
  return (
    <div className="fixed inset-0 z-[9001] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-[16px] shadow-lg w-[90%] max-w-[500px] p-8 text-center flex flex-col items-center gap-6 animate-fade-in">
        <h1 className="text-black text-[18px] md:text-[28px] font-semibold text-center mb-8">
          Your session has started
        </h1>
        <p className="text-[18px] leading-relaxed">
          We opened your session in a new tab. <br />
          If you don’t see it,{" "}
          <a
            href={dynamicURL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-blurple underline"
          >
            click here
          </a>{" "}
          to join right away.
        </p>

        <Button
          onClick={() => setOpenModal(false)}
          className="mt-8 w-[120px] text-[16px]"
        >
          Close
        </Button>
      </div>
    </div>
  )
}

export default JoinModal
